// Recurring task schedule
export interface RecurringSchedule {
  id: string
  customerId: string
  partnerId: string
  taskType: string
  dayOfMonth: number
  frequency: string // 'Monthly' | 'Quarterly'
  isActive: boolean
  createdByUserId?: string
  metadata?: string
  createdAt: string
  updatedAt: string
}

export interface CreateScheduleRequest {
  taskType: string
  dayOfMonth: number
  frequency: string
  metadata?: string
}

export interface UpdateScheduleRequest {
  dayOfMonth?: number
  frequency?: string
  isActive?: boolean
  metadata?: string
}

// Recurring task execution (history)
export interface RecurringTaskExecution {
  id: string
  recurringScheduleId: string
  customerId: string
  taskType: string
  scheduledDate: string
  status: string // 'TicketCreated' | 'PendingApproval' | 'Approved' | 'Rejected' | 'Failed'
  zendeskTicketId?: string
  externalReference?: string
  createdAt: string
  updatedAt: string
}

// Approval items
export interface ApprovalItemAttachment {
  id: string
  fileName: string
  contentType: string
  fileSize: number
  createdAt: string
}

export interface ApprovalItem {
  id: string
  executionId: string
  customerId: string
  customerName: string
  partnerId: string
  taskType: string
  title: string
  status: string // 'PendingApproval' | 'Approved' | 'Rejected'
  approvedByUserId?: string
  approvedAt?: string
  rejectedReason?: string
  validationMessage?: string
  createdAt: string
  updatedAt: string
  attachments: ApprovalItemAttachment[]
}

// Task type options are now derived from the recurring task type registry.
// Import TASK_TYPES from '../features/recurringTasks/taskTypeRegistry' instead.
// Keeping this re-export removed avoids a circular import between
// types/recurringTasks.ts and the registry (which pulls in a React component
// that itself imports these types).

export const FREQUENCY_OPTIONS = [
  { value: 'Monthly', label: 'Monthly' },
  { value: 'Quarterly', label: 'Quarterly' },
] as const

export const APPROVAL_STATUSES = [
  { value: 'PendingApproval', label: 'Pending Approval' },
  { value: 'Approved', label: 'Approved' },
  { value: 'AutoApproved', label: 'Auto-approved' },
  { value: 'CompletedManually', label: 'Completed manually' },
  { value: 'Rejected', label: 'Rejected' },
] as const

export interface BlitzAutoSyncRule {
  enabled: boolean
  cidn: string
  customerId: string
  partnerId: string
  accountNames: string[]
  enabledAt: string
  verifiedAt: string
  verifiedBy: string
  verifiedApprovalId: string
}

export interface BlitzReview {
  customerName: string
  expectedCidn: string
  cidn?: string
  accountNames: string[]
  newAccountNames: string[]
  statementMonth?: string
  total: number
  rows: number
  reviewToken: string
  errors: string[]
  warnings: string[]
  canPublish: boolean
  canCompleteManually: boolean
  autoSyncEnabled: boolean
}

export interface BlitzDecision {
  reviewToken: string
  customerConfirmed: boolean
  enableAutoSync: boolean
  completedManually: boolean
}
